

//T2 helper (updated)
        function waitForElement(selector, callback) {
          const element = document.querySelector(selector);
          if (element) {
            callback(element);
          } else {
            setTimeout(() => waitForElement(selector, callback), 100); // Retry after 100ms
          } 
        }

function t2(){
return false;

//helper only - get currency symbol and display from amount plus 3 digit code 
function formatCurrency(amount, code, locale = "en") {
  // force EUR to use a locale that places € before the number with comma
  const effectiveLocale = code === "EUR" ? "de-AT" : locale;

  let formatted = new Intl.NumberFormat(effectiveLocale, {
    style: "currency",
    currency: code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);

  //remove spacing if EUR.
  if (code === "EUR") {
    formatted = formatted.replace(/\s*(€)\s*/, "$1");
  }

  return (formatted);

}

//Update announcement banner
window.varify.helpers.waitFor('.announcement-bar__message span', (element) => {
  console.log("shopify_crcy:" + Shopify.currency.active);
  let shippingthreshold = parseFloat(30 * Shopify.currency.rate).toFixed(0);
  let currencyIcon = Shopify.currency.active;
  let formattedshpthres = formatCurrency(shippingthreshold, currencyIcon);
  let formattedthres_integer = convertPriceToInteger(formattedshpthres);

  function convertPriceToInteger(priceStr) {
    // Ersetzt alles nach dem Komma oder Punkt, behält nur Ganzzahl
    return priceStr.replace(/([^\d]*)(\d+)[.,]?\d*/, "$1$2");
  }

  console.log("shopify_crcy rate:" + Shopify.currency.rate);
  console.log("SHIP threshold " + formattedthres_integer);

  const announcementEl = element;
  if (announcementEl) {
    announcementEl.textContent = `LIMITED OFFER: 50% OFF + FREE SHIPPING OVER ${formattedthres_integer}`;
  }
});

//2nd announce bulletproof.

//update product page or any free shipping occurence (wf footer)
waitForElement('.shopify-section-group-footer-group', (element) => {
  let shippingthreshold = parseFloat(30 * Shopify.currency.rate).toFixed(0);
  let currencyIcon = Shopify.currency.active;
  let formattedshpthres = formatCurrency(shippingthreshold, currencyIcon);
  let formattedthres_integer = convertPriceToInteger(formattedshpthres);

  function convertPriceToInteger(priceStr) {
    // Ersetzt alles nach dem Komma oder Punkt, behält nur Ganzzahl
    return priceStr.replace(/([^\d]*)(\d+)[.,]?\d*/, "$1$2");
  }

  /*
    function replaceFreeShippingText(root = document.body) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      let node;
      while ((node = walker.nextNode())) {
        if (/free shipping/i.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(/free shipping/gi, "Free Shipping over £30");
        }
      }
    }
    */

  var affectedByShippingWording = false;

  function replaceFreeShippingText(root = document.body) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    let node;



    while ((node = walker.nextNode())) {
      // Skip if text already contains "£30"
      if (node.nodeValue.includes(formattedthres_integer)) continue;
      //if (/£30/.test(node.nodeValue)) continue;


      // Match "free shipping", "shipping is free", "worldwide free shipping"
      if (/(free\s+shipping|shipping\s+is\s+free|worldwide\s+free\s+shipping)/i.test(node.nodeValue)) {
        //NEW FOR DEBUG: GA4 "affected by shipping" event to debug.
        affectedByShippingWording = true;

        node.nodeValue = node.nodeValue.replace(
          /(free\s+shipping|shipping\s+is\s+free|worldwide\s+free\s+shipping)/gi,
          `Free Shipping over ${formattedthres_integer}`
        );
      }
    }

  }

  //function no2, safety only!
  function replaceFreeShippingText2(root = document.body) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    let node;

    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes(formattedthres_integer)) continue;
      // if (/£30/.test(node.nodeValue)) continue;


      // Flexible Regex: fängt Varianten wie "Free Worldwide Shipping" oder "Shipping is free" ab
      if (/\b(free|shipping|worldwide)\b/i.test(node.nodeValue)) {
        affectedByShippingWording = true;

        node.nodeValue = node.nodeValue.replace(
          /\b(free\s+shipping|shipping\s+is\s+free|worldwide\s+free\s+shipping|free\s+worldwide\s+shipping)\b/gi,
          `Free Shipping over ${formattedthres_integer}`
        );
      }
    }



  }

  // Aufrufen
  replaceFreeShippingText();
  replaceFreeShippingText2();

  //GA4 debug event send.

  if (affectedByShippingWording && typeof gtag === 'function') {
    if (affectedByShippingWording == true) {
      //SEND DEBUG GA4 event.
      gtag('event', 'debug_shipping_only', {
        event_category: 'debug_shipping_check',
        event_label: 'page_has_free_shipping_wording',
        value: 1
      });
    }
  }
});


//logic
waitForElement('.upcart-rewards', (element) => {

  //after current one insert new one, and need to hide new one!
  let currentbarEl = document.querySelector(".upcart-rewards");

  let newbarexists = document.querySelector(".t2.upcart-rewards");
  if (newbarexists) return;

  let newbarHtml = `
<div class="t2 upcart-rewards styles_TieredRewards__ UpcartDesignSettings__cartTextColor" style="user-select: text;">
  <div class="upcart-rewards-message" style="user-select: text;">
    <p style="user-select: text;">You're just a bit away from Free Shipping!</p>
  </div>
  <div class="upcart-rewards-bar-background styles_TieredRewards__progressBar__" style="background-color: rgb(226, 226, 226); user-select: text;">
    <div class="upcart-rewards-bar-foreground styles_Rewards__progressBar--progress__" style="background-color: rgb(54, 121, 180); width: 100%; user-select: text;">
    </div>
  </div>
  <div class="styles_TieredRewards__tiersContainer__" style="user-select: text;">
    <div style="user-select: text;">
    </div>
    <div class="upcart-rewards-tier styles_TieredRewards__tierCircleAndDescription__ styles_TieredRewards__tierCircleAndDescription--exactlyCenter__" style="user-select: text;">
      <div class="upcart-rewards-tier-circle shipping inactive styles_TieredRewards__tierCircle__" style="fill: rgb(226, 226, 226); background-color: rgb(54, 121, 180); user-select: text;">
        <div class="upcart-rewards-tier-icon" style="width: 25px; height: 25px; margin: auto; user-select: text;">
          <svg viewBox="0 0 20 20" style="user-select: text;">
            <path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" style="user-select: text;">
            </path>
            <path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z" style="user-select: text;">
            </path>
          </svg>
        </div>
      </div>
      <div class="upcart-rewards-tier-description styles_rewardsDescription__" style="user-select: text;">Free shipping</div>
    </div>
    <div class="upcart-rewards-tier styles_TieredRewards__tierCircleAndDescription__ styles_TieredRewards__tierCircleAndDescription--leftOfCenter__" style="user-select: text;">
      <div class="upcart-rewards-tier-circle gift inactive styles_TieredRewards__tierCircle__" style="fill: rgb(54, 121, 180);background-color: rgb(226, 226, 226);user-select: text;border: 2px solid rgb(54, 121, 180);">
        <div class="upcart-rewards-tier-icon" style="width: 25px; height: 25px; margin: auto; user-select: text;">
          <svg viewBox="0 0 20 20" style="user-select: text;">
            <path fill-rule="evenodd" d="M8.798 7.992c-.343-.756-1.098-1.242-1.928-1.242-1.173 0-2.119.954-2.119 2.122 0 1.171.95 2.128 2.125 2.128h.858c-.595.51-1.256.924-1.84 1.008-.41.058-.694.438-.635.848.058.41.438.695.848.636 1.11-.158 2.128-.919 2.803-1.53.121-.11.235-.217.341-.322.106.105.22.213.34.322.676.611 1.693 1.372 2.804 1.53.41.059.79-.226.848-.636.059-.41-.226-.79-.636-.848-.583-.084-1.244-.498-1.839-1.008h.858c1.176 0 2.125-.957 2.125-2.128 0-1.168-.946-2.122-2.119-2.122-.83 0-1.585.486-1.928 1.242l-.453.996-.453-.996Zm-.962 1.508h-.96c-.343 0-.625-.28-.625-.628 0-.344.28-.622.619-.622.242 0 .462.142.563.363l.403.887Zm3.79 0h-.96l.403-.887c.1-.221.32-.363.563-.363.34 0 .619.278.619.622 0 .347-.282.628-.625.628Z" style="user-select: text;">
            </path>
            <path fill-rule="evenodd" d="M2.499 6.75c0-1.519 1.231-2.75 2.75-2.75h9.5c1.519 0 2.75 1.231 2.75 2.75v2.945l.002.055c0 .018 0 .037-.002.055v3.445c0 1.519-1.231 2.75-2.75 2.75h-9.5c-1.519 0-2.75-1.231-2.75-2.75v-6.5Zm13.5 2.25h-1.248c-.414 0-.75.336-.75.75s.336.75.75.75h1.248v2.75c0 .69-.56 1.25-1.25 1.25h-4.748v-1c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-3.252c-.69 0-1.25-.56-1.25-1.25v-2.792c.292-.102.502-.38.502-.708 0-.327-.21-.606-.502-.708v-2.292c0-.69.56-1.25 1.25-1.25h3.252v.75c0 .414.336.75.75.75s.75-.336.75-.75v-.75h4.748c.69 0 1.25.56 1.25 1.25v2.25Z" style="user-select: text;">
            </path>
          </svg>
        </div>
      </div>
      <div class="upcart-rewards-tier-description styles_rewardsDescription__" style="user-select: text;">Free Gift</div>
    </div>
  </div>
</div>
`;

  currentbarEl.insertAdjacentHTML("afterend", newbarHtml);


});



//now logic to update the bar!
waitForElement('.styles_Footer__cartSubtotalValue__', (element) => {

  console.log("Shopify currency: " + Shopify.currency);
  var currencyIcon = Shopify.currency.active;
  var tier1Threshold = parseFloat((Shopify.currency.rate * 30).toFixed(2));
  var tier2Threshold = parseFloat((Shopify.currency.rate * 49).toFixed(2));

  console.log("Thresholds: ");
  console.log(tier1Threshold);
  console.log(tier2Threshold);

  // --- Selectors ---


  const progressBar = document.querySelector(".t2 .upcart-rewards-bar-foreground");
  const shippingIcon = document.querySelector(".t2 .upcart-rewards-tier-circle.shipping");
  const giftIcon = document.querySelector(".t2 .upcart-rewards-tier-circle.gift");
  const rewardsMessage = document.querySelector(".t2 .upcart-rewards-message");

  function function3() {
    console.log("Total > GBP 49");
    // Remove inactive from gift icon
    if (giftIcon) giftIcon.classList.remove("inactive");
    if (shippingIcon) shippingIcon.classList.remove("inactive");
  }

  function function2() {
    console.log("Total > GBP 30");
    // Remove inactive from shipping icon
    if (shippingIcon) shippingIcon.classList.remove("inactive");
    if (giftIcon) giftIcon.classList.add("inactive");
  }

  function function1() {
    console.log("Total < GBP 30 but > 0");
    // Add inactive class to both icons
    if (shippingIcon) shippingIcon.classList.add("inactive");
    if (giftIcon) giftIcon.classList.add("inactive");
  }

  function cartEmpty() {
    console.log("Cart is empty!");
    const newTiersWrapper = document.querySelector(".t2.upcart-rewards");
    // Optionally reset progress bar and icons
    //if (progressBar) progressBar.style.width = "0%";
    //if (shippingIcon) shippingIcon.classList.add("inactive");
    //if (giftIcon) giftIcon.classList.add("inactive");
    rewardsMessage.innerHTML = '';
    //maybe add hide class to wrapper
    newTiersWrapper.classList.add("hide");
  }

  //END CALLBACKS.

  // --- Utility to parse subtotal text ---
  function parseSubtotal(text) {
    // Remove non-digit, non-decimal characters
    const normalized = text.replace(/[^0-9,.\s]/g, '').replace(',', '.');
    return parseFloat(normalized) || 0;
  }
  // Function to check total and trigger callbacks

  function checkTotal(total) {
    //format money first
    console.log("CART TOTAL + " + total);

    if (total > tier2Threshold) {
      function3();
      rewardsMessage.textContent = "Congratulations! You're receiving a gift with your order!";

    } else if (total > tier1Threshold) {
      function2();
      let remaining = (tier2Threshold - total).toFixed(2);
      let remainingString = formatCurrency(remaining, currencyIcon);
      rewardsMessage.textContent = `You're ${remainingString} away from Free Gift`;

    } else if (total > 0) {
      function1();
      let remaining = (tier1Threshold - total).toFixed(2);
      let remainingString = formatCurrency(remaining, currencyIcon);
      rewardsMessage.textContent = `You're ${remainingString} away from Free Shipping`;

    }
  }

  function checkProgress(total) {
    if (total > 0) {
      if (progressBar) progressBar.style.width = `${(total / tier2Threshold) * 100}%`;
    } else {
      if (progressBar) progressBar.style.width = `0%`;
    }

  }


  // Target element
  const subtotalEl = document.querySelector(".styles_Footer__cartSubtotalValue__");

  if (subtotalEl) {
    // Run on initial load
    const initialTotal = parseSubtotal(subtotalEl.textContent);
    checkTotal(initialTotal);
    checkProgress(initialTotal);

    // Set up MutationObserver
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === "childList" || mutation.type === "characterData") {
          const newTotal = parseSubtotal(subtotalEl.textContent);
          checkTotal(newTotal);
          checkProgress(newTotal);
        }
      });
    });

    observer.observe(subtotalEl, { childList: true, characterData: true, subtree: true });
  } else {
    console.warn("Subtotal element not found!");
  }

  //observer 2 for empty cart.
  // --- Observer for cart empty state ---
  const cartContainer = document.body; // Observe the whole body or specific cart wrapper
  const emptyObserver = new MutationObserver(() => {
    const emptyEl = document.querySelector(".styles_CartPreview__empty__");
    if (emptyEl) {
      cartEmpty();
    }
  });

  // Watch for added/removed nodes in the body
  emptyObserver.observe(cartContainer, { childList: true, subtree: true });

  // --- Initial check for empty cart ---
  if (document.querySelector(".styles_CartPreview__empty__")) {
    cartEmpty();
  }

});


//end t2 funct.
}

t2();